<template>
  <div class="navbar-item has-dropdown is-hoverable">
      <a class="navbar-link">
        <img :src="icons[currentLocale]" class="country-icon" /> {{currentLocale}}
      </a>

      <div class="navbar-dropdown">
        <template v-for="locale in locales">
          <a class="navbar-item" v-bind:key="locale.code" @click="changeLocale(locale.code)">
            <img :src="icons[locale.code]" class="country-icon" />
            <span>{{locale.name}}</span>
          </a>
        </template>
      </div>
    </div>
</template>
 
<script>
import enIcon from 'svg-country-flags/svg/gb.svg'
import ruIcon from 'svg-country-flags/svg/ru.svg'
import { locales } from '@/utils'
export default {
  data() {
    return {
      icons: {
        en: enIcon,
        ru: ruIcon
      },
      locales: locales
    }
  },
  computed: {
    currentLocale() {
      return this.$store.getters.getLocale
    },
  },
  methods: {
    changeLocale(val){
      this.$store.dispatch('setLocale', val)
    }
  }
}
</script>
 
<style scoped>
  .country-icon {
    width: 20px;
    height: auto;
    display: inline-block;
    vertical-align: baseline;
    border: 1px solid #dee2e6;
    box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
  }

  .country-icon.as-toggle {
    margin-top: 5px;
  }

  .locale-name {
    display: inline-block;
    vertical-align: baseline;
  }
</style>